import * as React from 'react';

export default function ButtonArrow(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14.921} height={14.922} {...props}>
      <path
        data-name="Path 4015"
        d="m7.46 0 6.876 6.106a1.852 1.852 0 0 1 0 2.706L7.46 14.918l3.261-6.526L.672 7.927c-.371 0-.673-.209-.673-.466s.3-.466.673-.466l10.049-.465Z"
        fillRule="evenodd"
      />
    </svg>
  );
}
